export function formatInstanceOfCheck(check) {
  return `expected instance of ${check.class}`;
}
